import React from 'react';

const Header: React.FC = () => {
  return (
    <header></header>
    // <header className="bg-gray-800 text-white p-4">
    //   <div className="container mx-auto">
    //     <h1 className="text-xl">ボット制作タイピング</h1>
    //   </div>
    // </header>
  );
};

export default Header;
